import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import successIcon from '../assets/pic/check1.png';
import errorIcon from '../assets/pic/close.png';
import { Text } from "../languages/Language";
import { getStripeIntentId } from "../fetch/getStripeIntentId";

const StripeSuccess = ({ onSuccess }) => {
  const [message, setMessage] = useState("Payment is checking...");
  const [errorDetail, setErrorDetail] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const sessionId = query.get("session_id");

    getStripeIntentId(sessionId).then((response) => {

      if (response.resCode == 200) {
        sessionStorage.setItem('paymentTrackingId', response.paymentIntentId);

        setMessage("Paymennt successfully completed, redirecting to home page...");
        onSuccess?.();
        setTimeout(() => navigate("/"), 500);
      } else {
        setMessage("An error occurred.");
        setErrorDetail(response.resMessage);
      }

    });

  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4">
      {message.includes("successfully") && (
        <img src={successIcon} alt="Success" className="w-16 h-16 mb-4" />
      )}
      {message.includes("failed") && (
        <img src={errorIcon} alt="Failed" className="w-16 h-16 mb-4" />
      )}
      <div className="mb-4 animate-pulse text-lg font-semibold text-gray-700">{message}</div>
      {errorDetail && <div className="text-sm text-red-500">{errorDetail}</div>}
      {message.includes("failed") || message.includes("error") && (
        <button
          onClick={() => navigate("/")}
          className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
        >
          <Text tid="TurnHomePage" />
        </button>
      )}
    </div>
  );
};

export default StripeSuccess;
